import {
  currentDate,
  formatDateTimeShort,
  formatRelative,
  parseDate,
} from '@ardoq/date-time';
import { type Locale } from '@ardoq/locale';
import { logError } from '@ardoq/logging';
import { t, type I18nLocale } from '@ardoq/i18n';

type FormattedDateProps = {
  date: string | Date;
  isLocalDateFormat?: boolean;
  i18nLocale: I18nLocale;
  locale: Locale;
};

const getFormattedLocalDate = (
  date: string | Date,
  locale: Locale,
  i18nLocale: I18nLocale
) => {
  try {
    const targetDate = typeof date === 'string' ? parseDate(date) : date;

    return formatRelative(targetDate, currentDate(), { locale });
  } catch (error) {
    logError(error as Error, 'Failed to format relative date', { date });

    return t(
      i18nLocale,
      'atomicComponents:formattedDate.invalid',
      'Invalid date'
    );
  }
};

const FormattedDate = ({
  date,
  isLocalDateFormat,
  i18nLocale,
  locale,
}: FormattedDateProps) => {
  const formattedDateTime = formatDateTimeShort(date, locale);

  return (
    <span data-tooltip-text={formattedDateTime}>
      {isLocalDateFormat
        ? formattedDateTime
        : getFormattedLocalDate(date, locale, i18nLocale)}
    </span>
  );
};

export { FormattedDate };
